(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const initRelatedProducts = function() {
      const productRecommendationsSection = document.querySelector('.js-related-products');
      if (!productRecommendationsSection) return;

      const handleIntersection = function(entries, observer) {
        if (!entries[0].isIntersecting) return;

        observer.unobserve(productRecommendationsSection);

        const url = productRecommendationsSection.dataset.url;
        if (!url) return;

        fetch(url)
          .then(function(response) {
            return response.text();
          })
          .then(function(text) {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('.js-related-products');

            if (recommendations && recommendations.innerHTML.trim().length) {
              productRecommendationsSection.innerHTML = recommendations.innerHTML;

              const products = productRecommendationsSection.querySelectorAll('.s-related-product');
              if (products.length) {
                document.dispatchEvent(new CustomEvent('productsLoaded', {
                  detail: { products: Array.from(products) }
                }));
              }
            }
          })
          .catch(function(e) {
            console.error(e);
          });
      };

      const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});
      observer.observe(productRecommendationsSection);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initRelatedProducts);
    } else {
      initRelatedProducts();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
